import {
  ActionItemType,
  ActionItemWorkScope,
  ApprovalState,
  DamageMechanismType,
  FDMStatus,
  FFSResultType,
  FFSType,
  FacilityEnum,
  FindingType,
  PercentOverdue,
  ReferenceType,
  ReportType,
  RiskEvualationCategory,
  ShutDownType,
  TaskFrequency,
} from '../api/api-clientInformation';

export const ApprovalFlowStateOptions = [
  {
    value: ApprovalState.Draft,
    label: "Draft"
  },
  {
    value: ApprovalState.DraftedForReview,
    label: "Drafted for Review"
  },
  {
    value: ApprovalState.SubmittedToOpsAdvisor,
    label: "Submitted to Ops Advisor"
  },
  {
    value: ApprovalState.PlanConfirmed,
    label: "Plan Confirmed"
  },
  {
    value: ApprovalState.RIPTScored,
    label: "RIPT Scored"
  },
  // {
  //     value: ApprovalState.RIPTSkipped,
  //     label: "RIPT Skipped"
  // },
  {
    value: ApprovalState.RiskEvaluationScored,
    label: "Risk Evaluation Scored"
  },
  {
    value: ApprovalState.PlanEndorsed,
    label: "Plan Endorsed"
  },
  {
    value: ApprovalState.PlanApproved,
    label: "Plan Approved"
  },
  {
    value: ApprovalState.ResolutionPlanCompleted,
    label: "Resolution Plan Completed"
  },
  {
    value: ApprovalState.ValidationAndVerificationCompleted,
    label: "Validation & Verification Completed"
  },
  {
    value: ApprovalState.Closed,
    label: "Closed"
  },
  {
    value: ApprovalState.Cancelled,
    label: "Cancelled"
  },
  {
    value: ApprovalState.OutOfService,
    label: "Out of Service"
  },
  {
    value: ApprovalState.Recycle,
    label: "Recycle"
  }
];

export const FDMStatusOptions = [
  {
    value: FDMStatus.PreparationInProgress,
    label: "Preparation In Progress"
  },
  {
    value: FDMStatus.ExecutionInProgress,
    label: "Execution In Progress"
  },
  {
    value: FDMStatus.OutOfService,
    label: "Out Of Service"
  },
  {
    value: FDMStatus.Cancelled,
    label: "Cancelled"
  },
  {
    value: FDMStatus.Closed,
    label: "Closed"
  },
];
export const ActionItemTypeOptions = [
  {
    value: ActionItemType.AdministrativeTask,
    label: "Administrative Task"
  },
  {
    value: ActionItemType.MitigationTaskShortTerm,
    label: "Mitigation Task/ Short-Term"
  },
  {
    value: ActionItemType.ResolutionTaskLongTerm,
    label: "Resolution Task/ Long-Term"
  }
];

export const ActionItemWorkScopeOptions = [
  {
    value: ActionItemWorkScope.TA,
    label: "TA"
  },
  {
    value: ActionItemWorkScope.NonTA,
    label: "Non-TA"
  },
  {
    value: ActionItemWorkScope.NotAssigned,
    label: "Not Assigned"
  }
];

export const DamageMechanismTypeOptions = [
  {
    value: DamageMechanismType.DamageMechanism,
    label: "Damage Mechanism"
  },
  {
    value: DamageMechanismType.FailureMode,
    label: "Failure Mode"
  }
];


export const FFSTypeOptions = [
  {
    value: undefined,
    label: "Select FFS Performed"
  },
  {
    value: FFSType.NotAvailable,
    label: "Not Available"
  },
  {
    value: FFSType.No,
    label: "No"
  },
  {
    value: FFSType.FFS1,
    label: "FFS 1"
  },
  {
    value: FFSType.FFS2,
    label: "FFS 2"
  },
  {
    value: FFSType.FFS3,
    label: "FFS 3"
  }
];

export const ffsResultTypeOptions = [
  {
    value: undefined,
    label: "Select FFS Result"
  },
  {
    value: FFSResultType.Passed,
    label: "Passed"
  },
  {
    value: FFSResultType.Failed,
    label: "Failed"
  },
  {
    value: FFSResultType.NotAvailable,
    label: "Not Available"
  },
];

export const FacilityEnumOptions = [
  {
    value: FacilityEnum.TS,
    label: "TS"
  },
  {
    value: FacilityEnum.AFM,
    label: "AFM"
  },
  {
    value: FacilityEnum.EXP,
    label: "EXP"
  },
  {
    value: FacilityEnum.FGP,
    label: "FGP"
  },
  {
    value: FacilityEnum.Field,
    label: "Field"
  },
  {
    value: FacilityEnum.IOC,
    label: "IOC"
  },
  {
    value: FacilityEnum.KTL,
    label: "KTL"
  },
  {
    value: FacilityEnum.NonProductionFacility,
    label: "Non-Production Facility"
  },
  {
    value: FacilityEnum.NotAssigned,
    label: "Not Assigned"
  },
  {
    value: FacilityEnum.Power,
    label: "Power"
  },
  {
    value: FacilityEnum.SGISGP,
    label: "SGI/SGP"
  },
  {
    value: FacilityEnum.TengizFacilitiesMaintenance,
    label: "Tengiz Facilities Maintenance"
  },
  {
    value: FacilityEnum.TMF,
    label: "TMF"
  },
  {
    value: FacilityEnum.Utilities,
    label: "Utilities"
  }
];

export const FindingTypeOptions = [
  {
    value: undefined,
    label: "Select Finding Type"
  },
  {
    value: FindingType.Failed,
    label: "Failed"
  },
  {
    value: FindingType.StaticCondition,
    label: "Static Condition"
  },
  {
    value: FindingType.TimeDependentCondition,
    label: "Time Dependent Condition"
  }
];

export const DisciplineOptions = [
  {
    title: undefined, // Select Discipline
  },

  // old values - not available for creation
  {
    title: 'Automation SIS',
    notAvailableForCreation: true,
  },
  {
    title: 'Designs Engineering',
    notAvailableForCreation: true,
  },
  {
    title: 'Electrical Equipment',
    notAvailableForCreation: true,
  },
  {
    title: 'Fixed Equipment Valves',
    notAvailableForCreation: true,
  },
  {
    title: 'Fixed Equipment Vessels/Piping/Structural',
    notAvailableForCreation: true,
  },
  {
    title: 'Instrument Equipment',
    notAvailableForCreation: true,
  },
  {
    title: 'Pipeline and Corrosion',
    notAvailableForCreation: true,
  },
  {
    title: 'Pressure Safety Valves',
    notAvailableForCreation: true,
  },
  {
    title: 'Response and Egress',
    notAvailableForCreation: true,
  },
  {
    title: 'Risk Based Inspection',
    notAvailableForCreation: true,
  },
  {
    title: 'Rotating Equipment',
    notAvailableForCreation: true,
  },
  {
    title: 'Analyzers',    
    notAvailableForCreation: true,
  },
  {
    title: 'Operations',    
    notAvailableForCreation: true,
  },
  {
    title: 'Temporary Leak Repair',    
    notAvailableForCreation: true,
  },
  {
    title: 'Worst Actors',    
    notAvailableForCreation: true,
  },

  // available on creation
  {
    title: 'Safety instrumented system (SIS)',
    email: ''
  },
  {
    title: 'Instrumentation & Analyzers',
    email: ''
  },
  {
    title: 'Piperack / Cable rack / Buildings (per FIRM-10000)',
    email: ''
  },
  {
    title: 'Pipelines',
    email: ''
  },
  {
    title: 'Cathodic Protection',
    email: ''
  },
  {
    title: 'Fixed Equipment and process piping',
    email: ''
  },
  {
    title: 'Pressure Relief Devices (PRD)',
    email: ''
  },
  {
    title: 'Safety Selector Valves (SSV, or “Interlock”)',
    email: ''
  },
  {
    title: 'Critical Check Valves (CCV)',
    email: ''
  },
  {
    title: 'Flange connections (non-corrosion related issues)',
    email: ''
  },
  {
    title: 'Lifting & Rigging Equipment (including Cranes)',
    email: ''
  },
  {
    title: 'Firefighting and Fire Suppression Systems',
    email: ''
  },

];

export const PercentOverdueOptions = [
  {
    value: PercentOverdue.LessThan10,
    label: "< 10%"
  },
  {
    value: PercentOverdue.TenToLessThan20,
    label: "10% to < 20%"
  },
  {
    value: PercentOverdue.TwentyToLessThan30,
    label: "20% to < 30%"
  },
  {
    value: PercentOverdue.ThirtyToLessThan40,
    label: "30% to < 40%"
  },
  {
    value: PercentOverdue.Forty,
    label: ">= 40%"
  }
];

export const consequenceRankingOptions = [
  {
    value: 'IC1',
    label: 'IC1'
  },
  {
    value: 'IC2',
    label: 'IC2'
  },
  {
    value: 'IC3',
    label: 'IC3'
  },
  {
    value: 'IC4',
    label: 'IC4'
  },
  {
    value: 'IC5',
    label: 'IC5'
  },
  {
    value: 'IC6',
    label: 'IC6'
  },
  {
    value: 'AC1',
    label: 'AC1'
  },
  {
    value: 'AC2',
    label: 'AC2'
  },
  {
    value: 'AC3',
    label: 'AC3'
  },
  {
    value: 'AC4',
    label: 'AC4'
  },
  {
    value: 'AC5',
    label: 'AC5'
  },
  {
    value: 'AC6',
    label: 'AC6'
  },
  {
    value: 'NotAssigned',
    label: 'Not Assigned'
  }
];

export const ReferenceTypeOptions = [
  {
    value: ReferenceType.Ewr,
    label: "DEWIT EWR"
  },
  {
    value: ReferenceType.WorkOrder,
    label: "Work Order"
  },
  {
    value: ReferenceType.Moc,
    label: "MOC"
  }
  // ,
  // {
  //     value: ReferenceType.None,
  //     label: "None"
  // }
];
export const ReportTypeOptions = [
  {
    value: ReportType.IntegrityThreat,
    label: "Integrity Threat"
  },
  {
    value: ReportType.ReliabilityThreat,
    label: "Reliability Threat"
  },
  {
    value: ReportType.IntegrityDeficiency,
    label: "Integrity Deficiency"
  },
  {
    value: ReportType.ReliabilityDeficiency,
    label: "Reliability Deficiency"
  },
  {
    value: ReportType.TaskDeferral,
    label: "Task Deferral"
  },
  {
    value: ReportType.AnomalyReport,
    label: "Anomaly Report"
  }
];

export const RiskEvualationCategoryOptions = [
  {
    value: RiskEvualationCategory.HealthAndSafety,
    label: "Health and Safety"
  },
  {
    value: RiskEvualationCategory.Environmental,
    label: "Environmental"
  },
  {
    value: RiskEvualationCategory.Reputation,
    label: "Reputation"
  },
  {
    value: RiskEvualationCategory.Asset,
    label: "Asset"
  }
];

export const ShutDownTypeOptions = [
  {
    value: undefined,
    label: "Select TA Required"
  },
  {
    value: ShutDownType.Yes,
    label: "Yes"
  },
  {
    value: ShutDownType.No,
    label: "No"
  },
  {
    value: ShutDownType.TBD,
    label: "TBD"
  }
];

export const TaskFrequencyOptions = [
  {
    value: TaskFrequency.GreaterOrEqual5Years,
    label: ">= 5 Years"
  },
  {
    value: TaskFrequency.ThreeToLessThanFiveYears,
    label: "3 to < 5 Years"
  },
  {
    value: TaskFrequency.OneToLessThanThreeYears,
    label: "1 to < 3 Years"
  },
  {
    value: TaskFrequency.LessThanOneYear,
    label: "< 1 Year"
  }
];
